import { GeoPolygon } from '@porterin/booking-flow/src/order-review/domain/entities/GeoPolygon';
import { LatLng } from '@porterin/booking-flow/src/order-review/domain/entities/LatLng';
import { ParsedPolygonJson } from '@porterin/booking-flow/src/order-review/domain/types/PolygonTypes';

export const parsePolygonCoordinates = (polygon: string): GeoPolygon => {
  const parsedPolygon = JSON.parse(polygon) as ParsedPolygonJson;
  return parsedPolygon.coordinates.map((e: number[][]): LatLng[] => {
    return e.map((v): LatLng => {
      return { lat: v[1], lng: v[0] };
    });
  });
};

export const isCoordsUnderPolygon = (
  polygon: GeoPolygon,
  lat_lng: LatLng,
): boolean => {
  let googleLatLng = new window.google.maps.LatLng(lat_lng.lat, lat_lng.lng);
  return polygon.some((polygonCoords: LatLng[]) => {
    let newPolygon = new window.google.maps.Polygon({
      paths: polygonCoords,
    });
    return window.google.maps.geometry.poly.containsLocation(
      googleLatLng,
      newPolygon,
    );
  });
};
